import { csrfManager } from '../../../../../../lib-sat/csrf/csrf-manager';
import { apiRequestManager } from '../../../../../../lib-sat/api/api-request-manager';
import { globalLogger } from '../../../../../helper/global-logger';
import Analytics from './Analytics';

class EmailNotification {
    constructor() {}

    async handleJobEmailNotification(id) {
        const csrfToken = await csrfManager.getCsrfEmailNotification();
        let data = {
            _mailWhenJobDone: true,
            _csrf: csrfToken,
        };
        try {
            await apiRequestManager.post(`/api/jobs/${id}/notify/mail`, data);
            Analytics.send('notification_action', 'email_notification_success');
            return true;
        } catch (e) {
            Analytics.send('notification_action', 'email_notification_failed');
            return false;
        }
    }
}

export default new EmailNotification();
